import {
	IsEmail,
	IsNotEmpty,
	IsPhoneNumber,
	IsString,
	MinLength,
	Length,
	IsOptional,
	IsBoolean, ValidateNested
} from 'class-validator';
import { UpdateUserDto, UserDto } from "./user.dto";
import { Type } from "class-transformer";

export class AuthPhoneDto {
	@IsNotEmpty()
	@IsString()
	login: string;
}

export class AuthAsUserDto {
	@IsOptional()
	@IsString()
	login: string;

	@IsOptional()
	@IsString()
	id: string;

	@IsOptional()
	@IsString()
	userName: string;
}

export class BasicAuthDto {
	@IsNotEmpty()
	login: string;

	@IsNotEmpty()
	password: string;
}

export class AuthPhoneVerificationDto {
	@IsNotEmpty()
	@IsString()
	login: string;

	@Length(6, 6)
	code: string;
}

export class ConfirmationCodeDto {
	@Length(6, 6)
	code: string;
}

export class AdminLogin {
	@IsNotEmpty()
	@IsString()
	login: string;

	@IsNotEmpty()
	@IsString()
	password: string;
}

export class AuthEmailDto {
	@IsEmail()
	@IsNotEmpty()
	email: string;

	@IsNotEmpty()
	@Length(8, 20)
	password: string;
}

export class AdminAuthDto {
	@IsEmail()
	@IsNotEmpty()
	email: string;

	@IsNotEmpty()
	password: string;
}

export class RefreshTokenDto {
	@IsNotEmpty()
	@IsString()
	userId: string;

	@IsNotEmpty()
	@IsString()
	refreshToken: string;
}

export class TokensDto {
	@IsNotEmpty()
	@IsString()
	access_token: string;

	@IsNotEmpty()
	@IsString()
	refresh_token: string;
}

export class SignInUpTokenDto {
	@IsNotEmpty()
	@IsString()
	signInUpToken: string;

	@IsOptional()
	@IsBoolean()
	isUserAlreadyRegistered?: boolean;

	existingUserData?: UserDto | null;
}

export class SignUpWithTokenDto {
	@IsString()
	token: string;

	@ValidateNested()
	@Type(() => UpdateUserDto)
	userData: UpdateUserDto;
}

export class SignUpWithPhoneDto {
	@MinLength(3)
	@IsPhoneNumber()
	phone: string;
}

export class SignUpWithPhoneVerificationDto {
	@MinLength(3)
	@IsPhoneNumber()
	phone: string;

	@Length(6, 6)
	code: string;

	@IsOptional()
	@IsString()
	earlyAccessCode?: string;
}

export class GetUserOrUpsertTempUser {
	@MinLength(3)
	@IsPhoneNumber()
	phone: string;

	@IsEmail()
	@IsNotEmpty()
	email: string;

	@IsString()
	@IsNotEmpty()
	@MinLength(3)
	fullName: string;
}

export class SignUpWithWaitlistDto {
	@MinLength(3)
	@IsPhoneNumber()
	phone: string;

	@IsString()
	earlyAccessCode: string;
}

export class SignUpWithEmailDto {
	@IsEmail()
	email: string;

	@Length(8, 20)
	password: string;
}

export class RestorePasswordDto {
	@IsEmail()
	email: string;
}

export class RestorePasswordVerificationDto {
	@IsEmail()
	email: string;

	@Length(6, 6)
	code: string;
}

export class ChangePasswordDto {
	@Length(8, 20)
	password: string;
}

export class ApplePayloadDto {
	identityToken?: string;

	user?: {
		familyName?: string;
		givenName?: string;
	};
}

export class AppleTokenPayloadDto {
	email: string;
	email_verified: boolean;
	is_private_email: boolean;
	nonce: string;
	nonce_supported: boolean;
	auth_time: number;
	c_hash: string;
}
